import React, { useState } from "react";
import { EditCategory } from "../../pages";
import { MimaToastUtil } from "../../components";
import BusinessCategoryController from "../../controllers/BusinessCategoryController";
import constant from "../../utils/constant";
import * as yup from "yup";

const EditCategoryContainer = ({ closeModal, data }) => {
  const [loading, setLoading] = useState(false);

  const validationSchema = () => {
    return yup.object().shape({
      name: yup.string().required("Enter category name"),
      description: yup.string().required("Enter category description"),
    });
  };

  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      name: values.name,
      description: values.description,
    };
    const { status, errorMessage } =
      await BusinessCategoryController.editBusinessCategories(
        payload,
        data._id
      );

    if (status === constant.Success) {
      MimaToastUtil.success({ message: constant.Success });
      setLoading(false);
      return closeModal();
    } else {
      setLoading(false);
      MimaToastUtil.error({ message: errorMessage });
    }
  };
  return (
    <EditCategory
      loading={loading}
      onSubmit={onSubmit}
      closeModal={closeModal}
      data={data}
      validationSchema={validationSchema}
    />
  );
};
export default EditCategoryContainer;
